<template>
  <div class="l-learn-audio l-learn-content-container" v-if="element">
    <!-- 唱片 -->
    <img class="l-learn-audio-record" :class="{ rotate: isPlay == 1 }" src="./images/record.png" alt />
    <img class="l-learn-audio-handle" :class="{ 'handle-play': isPlay == 1, 'handle-play-no': isPlay == 2 }"
      src="./images/handle.png" alt />
    <lLearnCircle />
    <div class="l-learn-audio-play">
      <div class="l-learn-audio-bottom">
        <!-- 进度 -->
        <div class="l-progress">
          <!-- 进度条 -->
          <div ref="progressSection" class="l-progress-section">
            <div id="l-progress-audio" class="l-progress-box" draggable="false" onselectstart="return false;"
              oncontextmenu="return false;" ref="progressBox" @click="onCurrentTime">
              <div :style="{ width: `${audio.percent}%` }" ref="LProgress" class="l-progress-small">
                <span :class="{ cursor: false }" class="circle" @touchstart="handleTouchStart"></span>
              </div>
            </div>
          </div>
          <!-- 时间 -->
          <div class="l-time">
            <label class="l-time-show l-current-time">{{ audio.currentTime }}</label>
            <label class="l-time-show">{{ audio.totalTime }}</label>
          </div>
        </div>
        <!-- 播放按钮 -->
        <div class="l-audio-contrl">
          <span @click="onPlay(audio.play)" :class="{
            'l-pause': audio.play,
            'l-pause-none':
              audio.play && element.attrs && element.attrs.onceStopNum - element.pause <= 0,
          }" class="l-play"></span>
        </div>
        <span class="l-pause-number" v-if="element.ELEMENT_TYPE === ELEMENT_TYPES.AUDIO && element.attrs &&
          element.attrs.onceStopNum
          ">剩余暂停次数：{{ element.attrs.onceStopNum - element.pause }}次</span>
      </div>
    </div>
  </div>
</template>

<script>
import laudio from '@/utils/laudio'
import { recordStudyPlayData } from '@/utils/record'
import localKeyLock from '@/utils/localKeyLock'
import UPModel from '@/models/imgup'
import elementTypes from '../../minxin/elementTypes'
import lLearnCircle from '../../components/l-learn-circle'
import { createNamespacedHelpers } from 'vuex'
import TIP from '@/constants/tip'
const { mapGetters, mapActions } = createNamespacedHelpers('course')
const up = new UPModel()

const LOCAL_AUDIO_TIME = 'AUDIO_TIME'
const LOCAL_AUDIO_TIME_KEY = 'AUDIO_TIME_LAST_KEY'

export default {
  name: 'l-learn-audio',
  props: {
    autoplay: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    lLearnCircle,
  },
  mixins: [elementTypes],
  computed: {
    ...mapGetters(['element']),
  },
  data() {
    return {
      laudio: null,
      LOCAL_AUDIO_TIME_KEY: '',
      timeupdateTimer: null,
      audio: {
        target: null,
        play: false,
        totalTime: '',
        currentTime: '00:00:00',
        percent: 0,
        src: '',
        status: '',
        duration: 0,
      },
      mouse: false,
      clientX: 0,
      offset: 0,
      title: '',
      pauseNumber: 0,
      isDestoryed: false,
      isFirst: true,
      isPlay: false,
      playTimer: null,
      playTime: 0, // 进入页面开始播放的播放时长
    }
  },
  watch: {
    'element.ELEMENT_TYPE'(to) {
      this._setLocalKey()
      to ? this._initSourceUrl() : null
    },
    'element.isSubmit'(to) {
      if (to && this.element.ELEMENT_TYPE === this.ELEMENT_TYPES.AUDIO) {
        this._clearTime()
      }
    },
    async 'element.isCallBack'() {
      // 不是播放状态 直接返回
      if (this.laudio) {
        this.$emit('back')
        // 当前播放状态不是正在播放,可以返回
        // 学习提示-大复习指读-学习不需要减暂停次数
        // 当前录音有无限次可暂停次数,可以返回
        // if (
        //   !this.audio.play ||
        //   this.element.ELEMENT_TYPE === this.ELEMENT_TYPES.PREVIEW_AUDIO ||
        //   this.element.onceStopNum == -1
        // ) {
        //   this.$emit('back')
        //   return
        // }
        // // 没有剩余暂停次数，不能返回
        // if (this.element.leftPauseNum <= 0) {
        //   this.$lToast(TIP.NO_PAUSE)
        //   return
        // }
        // let res = this.STUDY_MEDIA_PAUSE({
        //   elementId: this.element.id,
        // })
        // if (res) {
        //   console.log('手动暂停，使用了暂停次数')
        //   this.$emit('back')
        // }
      }
    },
  },
  mounted() {
    if (this.element) {
      console.log('element', this.element)
      this._setLocalKey()
      this._initSourceUrl()
    }
  },
  methods: {
    ...mapActions(['STUDY_MEDIA_PAUSE']),
    handleTouchStart() {
      document.addEventListener('touchmove', this.handleTouchMove)
      document.addEventListener('touchup', this.handleTouchEnd)
      document.addEventListener('touchend', this.handleTouchEnd)
      document.addEventListener('touchcancel', this.handleTouchEnd)
    },
    handleTouchMove(e) {
      if (this.$route.params.elementType == 1) {
        let leftDistance =
          e.changedTouches[0].clientX -
          document.getElementById('l-progress-audio').getBoundingClientRect()
            .left
        let allWidth = document.getElementById('l-progress-audio').offsetWidth
        this.laudio.currentTime =
          (leftDistance / allWidth) *
          (this.laudio.duration
            ? this.laudio.duration
            : this.element.audioDuration / 1000)
      }
    },
    handleTouchEnd(e) {
      if (this.$route.params.elementType == 1) {
        let leftDistance =
          e.changedTouches[0].clientX -
          document.getElementById('l-progress-audio').getBoundingClientRect()
            .left
        let allWidth = document.getElementById('l-progress-audio').offsetWidth
        this.laudio.currentTime =
          (leftDistance / allWidth) *
          (this.laudio.duration
            ? this.laudio.duration
            : this.element.audioDuration / 1000)
      }
    },
    //点击可以快进
    onCurrentTime(event) {
      if (this.$route.params.elementType == 1) {
        if (event.target._prevClass != 'circle') {
          //小说录音的时候可以点击快进
          let allWidth = document.getElementById('l-progress-audio').offsetWidth
          let leftVal = event.offsetX
          this.laudio.currentTime =
            (leftVal / allWidth) *
            (this.laudio.duration
              ? this.laudio.duration
              : this.element.audioDuration / 1000)
        }
      }
    },
    onPlay() {
      this.audio.play ? this.laudio.pause() : this.laudio.play()
      this.laudio.currentTime = Number(this._getTime())
      this.audio.currentTime = this._format(this.laudio.currentTime)
      if (
        this.audio.currentTime >=
        (this.laudio.duration
          ? this.laudio.duration
          : this.element.audioDuration / 1000)
      ) {
        if (this.audio.status !== 'ended') {
          this._ended()
        }
      }
    },
    // 设置本地缓存
    _setLocalKey() {
      // 当前学习元素+当前学生记录+当前题目
      const currentValueKey = `${LOCAL_AUDIO_TIME}_${this.element.RECORD_ID}`
      const localKey = LOCAL_AUDIO_TIME_KEY
      this.LOCAL_AUDIO_TIME_KEY = localKeyLock(localKey, currentValueKey)
    },
    _initEvent() {
      // 监听播放事件
      this.laudio.addEventListener('play', () => {
        this.audio.play = true
        this.audio.status = 'play'
        this.isPlay = 1
        this._countTime()
      })

      // 监听暂停事件
      this.laudio.addEventListener('pause', () => {
        clearInterval(this.playTimer)
        setTimeout(() => {
          if (
            !this.isDestoryed &&
            this.audio.status != 'ended' &&
            this.element.ELEMENT_TYPE === this.ELEMENT_TYPES.AUDIO
          ) {
            this._setpauseNumber()

          }
          this.audio.play = false
          this.audio.status = 'pause'
          this.isPlay = 2
        }, 400) // 延迟以兼容ended状态延迟100毫秒更新
      })

      // 进度条(兼容ios有些时候不触发问题)
      this.timeupdateTimer = setInterval(() => {
        // 为了解决横竖屏/息屏 录音每次从0开始的问题
        if (this._getTime() && this.isFirst) {
          this.laudio.currentTime = localStorage.getItem(
            this.LOCAL_AUDIO_TIME_KEY
          )
          this.isFirst = false
        }
        let allTime = this.element.audioDuration / 1000
        if (!isNaN(this.laudio.duration ? this.laudio.duration : allTime)) {
          const currentTime = this._format(
            this.laudio.duration ? this.laudio.duration : allTime
          )
          if (this.audio.currentTime !== currentTime) {
            this.audio.percent = (
              (this.laudio.currentTime /
                (this.laudio.duration ? this.laudio.duration : allTime)) *
              100
            ).toFixed()
            let time = this.laudio.currentTime
              ? this.laudio.currentTime
              : this._getTime()
                ? this._getTime()
                : 0
            this.audio.currentTime = this._format(time)
            // 缓存本地
            localStorage.setItem(this.LOCAL_AUDIO_TIME_KEY, time)
          } else {
            this.audio.status = 'ended'
            clearInterval(this.timeupdateTimer)
            this.timeupdateTimer = null
          }
        }
      }, 100)

      // 音频初始化完成
      this.laudio.addEventListener('canplay', (e) => {
        if (!this.audio.totalTime) {
          this.audio.totalTime = this._format(
            e.target.duration
              ? e.target.duration
              : this.element.audioDuration / 1000
          )
        }
      })
      // 兼容safar浏览器 平板初始化暂停无法展示音频总时长
      this.laudio.load()

      // 播放完成
      this.laudio.addEventListener('ended', () => {
        // if (this.audio.status !== 'ended') {
        this.audio.status = 'ended'
        this._ended()
        // }
      })

      this.laudio.addEventListener('loadedmetadata', (e) => {
        // 上次时间
        if (this._getTime()) {
          e.target.currentTime = this._getTime()
          this.audio.currentTime = this._getTime()
          this.laudio.currentTime = this._getTime()
        }
      })
    },
    _getTime() {
      return localStorage.getItem(this.LOCAL_AUDIO_TIME_KEY)
    },
    // 格式时间
    _format(timezone) {
      // 取整，防止计算大浮点数
      timezone = parseInt(timezone)
      let time = []
      time[0] = parseInt(timezone / 60 / 60)
      time[1] = parseInt((timezone - time[0] * 60 * 60) / 60)
      time[2] = parseInt((timezone - time[0] * 60 * 60) % 60)

      time = time.map((item) => {
        return this._padStart(item)
      })
      return time.join(':')
    },
    _padStart(number) {
      return number < 10 ? `0${number}` : number
    },
    // 清除时间
    _clearTime() {
      localStorage.removeItem(this.LOCAL_AUDIO_TIME_KEY)
    },
    _initSourceUrl() {
      let paths = []
      if (this.element.ELEMENT_TYPE === this.ELEMENT_TYPES.PREVIEW_AUDIO) {
        paths = [this.element.resource]
        this.title = this.element.name
      }
      if (this.element.ELEMENT_TYPE === this.ELEMENT_TYPES.AUDIO) {
        paths = [this.element.attrs.audioUrl]
        this.title = this.element.name
      }

      this.$lLoading.show()
      up.resource({ paths: paths })
        .then((res) => {
          this.$lLoading.hide()
          this.audio.src = res.data[0]
          this._initAudio()
        })
        .catch((err) => {
          this.$lLoading.hide()
          console.log(err.msg)
        })
    },
    async _initAudio() {
      if (this.audio.src) {
        this.laudio = laudio({
          autoplay: this.autoplay,
          src: this.audio.src,
        })
      }

      if (this.laudio) {
        this._initEvent()
      }
    },
    // 设置暂停次数
    _setpauseNumber() {
      // 当前元素有无限次暂停次数，直接返回
      if (this.element.onceStopNum == -1) {
        return
      }
      // 当前元素无暂停次数，直接返回
      if (this.element.leftPauseNum === 0) {
        this.$lToast(TIP.NO_PAUSE)
        this.laudio.play()
        return
      }
      let res = this.STUDY_MEDIA_PAUSE({
        elementId: this.element.id,
      })
      if (res) {
        console.log('手动暂停，使用了暂停次数')
      }
    },
    // 结束
    _ended() {
      this.audio.play = false
      this.audio.status = 'ended'

      // 处理播放时长统计
      clearInterval(this.playTimer)
      recordStudyPlayData({
        id: this.element.id,
        bizType: this.element.type,
        type: 1,
        offset: this.playTime,
      }, this.element.ELEMENT_TYPE)

      // 提交
      if (this.element.ELEMENT_TYPE === this.ELEMENT_TYPES.AUDIO) {
        this.$emit('submit')
      } else {
        this._clearTime()
        console.log('播放完毕，返回时间处理')
        this.$emit('ended')
      }
    },

    // 播放计时
    _countTime() {
      this.playTimer = setInterval(() => {
        this.playTime += 1
        console.log('播放时间', this.playTime)
      }, 1000)
    },
  },
  destroyed() {
    // 处理播放时长统计
    if (this.playTimer) {
      clearInterval(this.playTimer)
    }
    recordStudyPlayData({
      id: this.element.id,
      bizType: this.element.type,
      type: 1,
      offset: this.playTime,
    }, this.element.ELEMENT_TYPE)

    this.isDestoryed = true
    if (this.audio.status !== 'ended') {
      this.laudio ? this.laudio.pause() : null
    }
    clearInterval(this.timeupdateTimer)
    this.timeupdateTimer = null
  },
}
</script>

<style lang="stylus" scoped>
@import './index.styl'
</style>
